enum ConsentResultEnum {
    AUTHORIZED = "AUTHORIZED",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
}

export default ConsentResultEnum;
